import AccountNotFoundMobile from './AccountNotFoundMobile';

export default AccountNotFoundMobile;
